import { RouteRecordRaw } from "vue-router";

export const landingRoutes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Landing",
    component: () => import("./views/LandingView.vue"),
    meta: { title: "Inicio" },
  },
];
